import { JsonAPIDocument, JsonAPIErrors } from 'json-api-hooks';
import { FieldValues, UseFormSetError } from 'react-hook-form';

import { FormFieldDefinition } from '../ResourceForm';

export const GENERAL_ERRORS = 'generalErrors';

const findAttribute = (attributes: string[], parameter: string | undefined, prefix?: string): string => {
  const prefixedParameter = `${prefix ?? ''}${parameter}`;
  const prefixedWithoutIndex = prefixedParameter.replace(/\.[0-9]+\./g, '.');

  if (parameter?.includes('.')) {
    const [newPrefix, ...rest] = parameter.split('.');

    return findAttribute(
      attributes,
      rest.join('.'),
      `${prefix ?? ''}${/^\d+$/.test(newPrefix) ? newPrefix : `${newPrefix}Attributes`}.`,
    );
  }
  if (attributes.includes(prefixedWithoutIndex)) {
    return prefixedParameter;
  } else if (attributes.includes(`${prefixedWithoutIndex}Id`)) {
    return `${prefixedParameter}Id`;
  } else {
    return GENERAL_ERRORS;
  }
};

const addError = (result: Record<string, string[]>, key: string, value: string) => {
  if (!Object.keys(result).includes(key)) {
    result[key] = [];
  }
  result[key].push(value);
};

const attributeNames = (fields: FormFieldDefinition[]): string[] =>
  fields.flatMap((field) =>
    field.nestedFields
      ? attributeNames(field.nestedFields).map((attr) => `${field.attribute}.${attr}`)
      : field.attribute,
  );

const parseAttributeErrors = (fields: FormFieldDefinition[], errors?: JsonAPIErrors) => {
  const attributes = attributeNames(fields);

  return (errors ?? []).reduce<Record<string, string[]>>((result, error) => {
    const parameter = findAttribute(attributes, error.source?.parameter);
    addError(result, parameter, error.title);

    return result;
  }, {});
};

const parseErrors = (json: JsonAPIDocument, fields: FormFieldDefinition[], setError: UseFormSetError<FieldValues>) => {
  const attributeErrors = parseAttributeErrors(fields, json.errors);
  if (!attributeErrors[GENERAL_ERRORS]) {
    addError(attributeErrors, GENERAL_ERRORS, 'Opslaan is niet gelukt');
  }

  Object.keys(attributeErrors).forEach((key) => {
    setError(key, {
      message: attributeErrors[key].join('\n'),
      type: 'server',
    });
  });
};

export default parseErrors;
